import { useEffect, useRef } from 'react';
import { useBounceLoop } from '../hooks/useBounceLoop';

const CANVAS_WIDTH = 240;
const CANVAS_HEIGHT = 320;

export const BounceCanvas = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useBounceLoop(canvasRef);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = CANVAS_WIDTH * dpr;
    canvas.height = CANVAS_HEIGHT * dpr;
    const ctx = canvas.getContext('2d');
    if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }, []);

  return <canvas ref={canvasRef} className="game-canvas" />;
};

export default BounceCanvas;


